export default {
  // Style prefix
  stylePrefix: 'cm-',

  inlineCss: false
};



// WEBPACK FOOTER //
// webpack://grapesjs/src/code_manager/config/config.js